import { render, staticRenderFns } from "./TrainingManage.vue?vue&type=template&id=0809ed4c&"
import script from "./TrainingManage.vue?vue&type=script&lang=js&"
export * from "./TrainingManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports